---
title: FFT Noise Filtering
coverImage: /blog/assets/images/fft-noise.avif
date: 2023-10-04T20:34:02.0400Z
excerpt: Building an application to filter white noise from sound files.
hidden: false
tags:
  - Math
---

<script>import Image from "@lib/components/atoms/Image.svelte";</script>

### What is the FFT?

FFT is an algorithm for transforming signals in the time domain into the frequency domain.
In college I did a project to filter sound files with the FFT.
It can be used for many things.

#### Links, inspiration, etc

github.com/jackbellinger/fast-and-furious-transformers

### Learnings

### Todo

- [x] Write the press release
- [ ] Update the website
- [ ] Contact the media
